import { MANAGED_CONNECTORS_FLAG } from "../../shared/featureFlagNames";
import { config } from "../environment";
import { useFeatureFlag } from "./useFeatureFlag";
import { useManagedAIProvider } from "./useManagedAIProvider";

export function useManagedConnectorsEnabled() {
  const flagEnabled = useFeatureFlag(MANAGED_CONNECTORS_FLAG);
  const { disabled } = useManagedAIProvider();
  return (
    !!flagEnabled && !disabled && config.managedAiConnectorProviders.length > 0
  );
}

// Chat and build run managed AI through Bedrock, so a stack serving only
// OpenAI can't offer the 3B managed AI provider.
export function useThreeBAIProviderOffered() {
  return (
    useManagedConnectorsEnabled() &&
    config.managedAiConnectorProviders.includes("bedrock")
  );
}
